export default __webpack_public_path__ + "static/flag-fi-1d2b4381b3636f11898ad35013c77ba3.svg";